import { AttendancesConfigAPI } from './config'
import { AttendancesRecordsAPI } from './records'

export const AttendancesAPI = {
  Config: AttendancesConfigAPI,
  Records: AttendancesRecordsAPI,
}
